import { DestinationParams } from '@anm/api/modules/stream/types';
import { InitialEditModalState } from '@anm/components/stream/types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { LiveStream } from 'types/stream';

import { streamSelectors } from '../../../store/modules/stream';
import { videoFolderSelectors } from '../../../store/modules/videoFolder';

const getDestinationParams = (stream: LiveStream) =>
  stream.destinations.reduce((acc, d) => {
    acc[d.destination_id] = d.request;
    return acc;
  }, {} as DestinationParams);

const useInitialStreamState = (streamId?: string) => {
  const stream = useSelector(state => streamSelectors.selectStreamById(state, streamId))!;
  const rootFolderId = useSelector(videoFolderSelectors.selectCurrentFolder)?.id;
  const roomSettings = useSelector(streamSelectors.selectRoomSettings);

  if (!stream) return [] as const;

  const { kind, schedule, meta } = stream;

  const initialModalState: InitialEditModalState = {
    kind,
    schedule,
    title: meta.title,
    preview: meta.preview,
    folderId: meta.folderId || rootFolderId,
    isWebinar: !!meta.webinarId,
    description: meta.description,
    destinationParams: getDestinationParams(stream)
  };
  const [initialState, setInitialState] = useState(initialModalState);

  useEffect(() => {
    if (initialState.canGuestAddDestination === undefined && roomSettings) {
      setInitialState(prev => ({ ...prev, canGuestAddDestination: !!roomSettings?.guestsCanAddDestinations }));
    }
  }, [roomSettings?.guestsCanAddDestinations]);

  return [initialState, meta.hostedVideoId] as const;
};

export default useInitialStreamState;
